import $ from "jquery";
import { toast } from "react-toastify";
import { apiURL } from "../utlis/config";
import store from "store";
var Actions = {
  ///trainee/notification
  addInvoice: (info) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/invoice";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  updatePolicyPlan: (info) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/policy/plan";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  fetchInvoice: (
    undefined,
    invoiceStatus,
    pageSize,
    page,
    searchText,
    startDate,
    endDate
  ) => {
    console.log({ pageSize, page, searchText, startDate, endDate });
    //console.log("startDate  ==", startDate !== "" ? searchText : undefined)

    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/invoice";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: {
          // dealerType: dealerType,
          limit: pageSize,
          page: page,
          searchText: searchText !== "" ? searchText : undefined,
          startDate:
            startDate !== "" && startDate !== "Invalid date"
              ? startDate
              : undefined,
          endDate:
            endDate !== "" && endDate !== "Invalid date" ? endDate : undefined,
        },
        success: function (response) {
          if (!response.error) {
            if (page == 0 && response.data.length > 0) {
              toast.info(
                response.memberMessage,
                {
                  position: toast.POSITION.TOP_CENTER,
                },
                { autoClose: 500 }
              );
            }
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  fetchInvoiceNumber: () => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/invoice/number";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: {},
        success: function (response) {
          // if (!response.error) {
          //   toast.info(
          //     response.memberMessage,
          //     {
          //       position: toast.POSITION.TOP_CENTER,
          //     },
          //     { autoClose: 500 }
          //   );
          // } else {
          //   toast.error(
          //     response.memberMessage,
          //     {
          //       position: toast.POSITION.TOP_CENTER,
          //     },
          //     { autoClose: 500 }
          //   );
          // }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },
};

export default Actions;
